import React from 'react';
import { OwnerWalletPage } from './OwnerWalletPage';

export function WithdrawalsPage() {
  return <OwnerWalletPage initialTab="withdrawals" />;
}
